import MapWrapper from '../../map-wrapper';
import LocationFilters from '../../location-filters';
import './style.scss';
import StoreCards from '../../store-cards';
import StoreList from './store-list';
import NewItkLocationFilters from './location-filters';
import { BreadcrumbSeparatorIcon } from './icons';
import FeatureFilters from './feature-filters';

export default function NewItk() {
    return (
        <section className="where new-itk">
            <div className="where__head">
                <div className="container">
                    <div className="breadcrumbs">
                        <ul className="breadcrumbs__list">
                            <li
                                className="breadcrumbs__item"
                                itemProp="itemListElement"
                                itemScope
                                itemType="http://schema.org/ListItem"
                            >
                                <a className="breadcrumbs__link" href="/" title="Главная">
                                    <span itemProp="name">Главная</span>
                                </a>
                                <BreadcrumbSeparatorIcon />
                            </li>
                            <li
                                className="breadcrumbs__item"
                                itemProp="itemListElement"
                                itemScope
                                itemType="http://schema.org/ListItem"
                            >
                                <span className="breadcrumbs__link" title="Где купить">
                                    <span itemProp="name">Где купить</span>
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="container">
                    <h1 className="where__title">Где купить?</h1>
                </div>
            </div>
            <div className="container">
                <FeatureFilters />
            </div>
            <div className="map-layout">
                <div className="map-layout__cont">
                    <div className="container">
                        <LocationFilters render={NewItkLocationFilters} />
                        <StoreCards render={StoreList} pageSize={500} />
                    </div>
                </div>
                <MapWrapper className="map" width="100%" height="100%" />
            </div>
        </section>
    );
}
